module.exports = __webpack_public_path__ + "static/media/kominfo-team-2.6e7ab94c.png";